import { DropdownReducerActionTypes } from '../types/DropdownReducerActionTypes';
/**
 * An action dispatchable to DropdownReducer.
 * Fire when a navigational key is pressed while the menu is open.
 *
 * @param {string} key
 */
export var navigateListAction = function (key) { return ({
    type: DropdownReducerActionTypes.NavigateList,
    payload: {
        key: key,
    },
}); };
//# sourceMappingURL=navigateListAction.js.map